import { Box, Drawer, DrawerProps, IconButton, LinearProgress } from '@mui/material';
import { getReportBuilderUrl } from '../../../common/lib/reportBuilderApi';
import { Icon } from '@iconify/react';
import { JSX, useEffect, useState } from 'react';

export interface ReportPreviewDialogProps {
  /**
   * Name of the report section that preview should be rendered for
   */
  sectionName: string;
  /**
   * ID of the report detail entity to preview
   */
  reportId: number;
  /**
   * Keyword param for the preview url.
   * Some sections need this param to determine what doc to preview.
   */
  keyword?: string;
  /**
   * Language code for the preview url.
   */
  language?: string;
}

/**
 * Render a preview dialog of the report for the given category.
 * Used in the report wizard.
 */
const ReportPreviewDialog = ({
  sectionName,
  reportId,
  keyword,
  language,
  ...dialogProps
}: ReportPreviewDialogProps & DrawerProps): JSX.Element => {
  const [isLoaded, setIsLoaded] = useState(false);

  // Reset loading state when dialog is closed
  useEffect(() => {
    if (!dialogProps.open) {
      setIsLoaded(false);
    }
  }, [dialogProps.open]);

  return (
    <Drawer anchor="right" PaperProps={{ sx: { width: 1, maxWidth: 700 } }} {...dialogProps}>
      <Box className="flex flex-col h-full">
        <Box className="flex justify-end fixed left-0 right-0">
          <IconButton onClick={(): void => dialogProps.onClose?.({}, 'escapeKeyDown')}>
            <Icon icon="material-symbols:close" width={20} />
          </IconButton>
        </Box>
        {!isLoaded && <LinearProgress />}
        <Box className="flex-grow">
          <iframe
            width="700px"
            height="100%"
            src={`${getReportBuilderUrl()}/reports/${reportId}?sectionName=${sectionName}${
              keyword ? `&keyword=${keyword}` : ''
            }&language=${language}`}
            onLoad={(): void => setIsLoaded(true)}
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default ReportPreviewDialog;
